import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {MatSlideToggleChange} from '@angular/material/slide-toggle';
import {SliderToggleResponseModel} from '@shared/components/slide-toggle/model/slider-toggle-response.model';
import {SettingsEnum} from '@core/enums/settings.enum';

@Component({
    selector: 'app-slide-toggle',
    templateUrl: './slide-toggle.component.html',
    styleUrls: ['./slide-toggle.component.scss']
})
export class SlideToggleComponent implements OnInit {
    @Input() cssClasses: string;
    @Input() ariaLabel: string;
    @Input() checked: boolean;
    @Input() labelClasses: string;
    @Input() labelPosition: 'before' | 'after';
    @Input() labelText: string;
    @Input() labelWidth: string;
    @Input() disableRipple: boolean;
    @Input() disabled: boolean;
    @Input() settingName: SettingsEnum;
    @Input() labelOff: boolean;
    @Output() slideToggleEvent: EventEmitter<SliderToggleResponseModel> = new EventEmitter();

    tabIndex: number;
    response: SliderToggleResponseModel;

    ngOnInit(): void {
        this.tabIndex = this.disabled === true ? -1 : 0;
    }

    slided(event: MatSlideToggleChange): void {
        this.response = {
            setting: this.settingName,
            selected: event.checked
        };
        this.slideToggleEvent.emit(this.response);
    }
}
